__turbopack_context__.v({
  "serviceTypeModalForm": "nOXB8a_serviceTypeModalForm",
  "serviceTypeModalForm__actions": "nOXB8a_serviceTypeModalForm__actions",
  "serviceTypeModalForm__rateHint": "nOXB8a_serviceTypeModalForm__rateHint",
});
